import React, { useState, useEffect } from "react";
import "./ReservationStyles.scss";
import SideBar from "../../../components/ReservationComponents/sideBar/SideBar";
import TopBar from "../../../components/ReservationComponents/topBar/TopBar";
import { useNavigate } from "react-router-dom";
import Drawer from "../../../components/ReservationComponents/drawer/Drawer";
import FloorView from "./floorView/FloorView";
import guestImg from "../../../assets/guest.svg";
import walk from "../../../assets/walking.svg";
import wait from "../../../assets/wait.svg";
import tick from "../../../assets/checkmark.png";
import InputComponent from "../../../components/inputcomponent/InputComponent";
import NumberInputComponent from "../../../components/inputcomponent/NumberInputComponent";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../application/store";
import Button from "../../../components/button/Button";
import NumberInput from "../../../components/ReservationComponents/numberInput/NumberInput";
import calendar from "../../../assets/clIC.svg";
import timeImg from "../../../assets/alarm.svg";
import covers from "../../../assets/friends.png";
import duration from "../../../assets/duration.png";
import table from "../../../assets/cover.svg";
import status from "../../../assets/status.png";
import est from "../../../assets/milestone.png";
import notes from "../../../assets/notes.svg";
import back from "../../../assets/arrow.png";
import arrow from "../../../assets/grd-arr.svg";
import DurationInput from "../../../components/ReservationComponents/numberInput/DurationInput";
import "react-datepicker/dist/react-datepicker.css";
import StatusModal from "../../../components/ReservationComponents/modal/statusModal/StatusModal";
import CoverModal from "../../../components/ReservationComponents/modal/coverModal/CoverModal";
import DurationModal from "../../../components/ReservationComponents/modal/durationModal/DurationModal";
import moment from "moment";
import DateModal from "../../../components/ReservationComponents/modal/dateModal/DateModal";
import CommentModal from "../../../components/ReservationComponents/modal/commentsModal/CommentsModal";
import NotesModal from "../../../components/ReservationComponents/modal/noteModal/NotesModal";
import TimeModal from "../../../components/ReservationComponents/modal/timeModal/TimeModal";
import TagModal from "../../../components/ReservationComponents/modal/tagModal/TagModal";
import EstModal from "../../../components/ReservationComponents/modal/estModal/EstModal";
import TimeInput from "../../../components/ReservationComponents/numberInput/TimeInput";
import Alert from "./tableDetails/Alert";
import {
  makeReservationInhouse,
  getStatus,
  getTags,
  getBlockedReservations,
} from "../../../../infra/apis/bookings/requests/Booking";
import {
  setAllocatedTables,
  setBookingStatus,
  setBookingTags,
} from "../../../../application/reducer/bookingSlice";
import SuccessModal from "../../../components/ReservationComponents/errorModal/SuccessModal";
import TableErrorModal from "../../../components/ReservationComponents/errorModal/TableErrorModal";
import SearchInput from "../../../components/ReservationComponents/searchInput/SearchInput";
import CustomerModal from "../../../components/ReservationComponents/modal/customerModal/CustomerModal";
import { searchCustomers } from "../../../../infra/apis/bookings/requests/CustomerManagement";
import WarningModal from "../../../components/ReservationComponents/errorModal/WarningModal";
import BookingFailed from "../../../components/ReservationComponents/errorModal/BookingFailed";

const NewReservation: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(
    localStorage.getItem("drawerOpen")
      ? JSON.parse(localStorage.getItem("drawerOpen") || "false")
      : false
  );
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    rules: false,
    guest: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [waitCheck, setWaitCheck] = useState<boolean>(false);
  const [walkCheck, setWalkCheck] = useState<boolean>(false);
  const [interval, setInterval] = useState<number>(120);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [guest, setGuest] = useState<number>(1);
  const [date, setDate] = useState<any>(new Date());
  const [bookingTime, setBookingTime] = useState<any>(
    moment(new Date()).format("HH:mm")
  );
  const [time, setTime] = useState<string>("0 min");
  const [request, setRequest] = useState<string>("");
  const [comments, setComments] = useState<string>("");
  const [statusValue, setStatusValue] = useState<any>("");
  const [tags, setTagsData] = useState<any[]>([]);
  const [isRequestOpen, setRequestOpen] = useState<boolean>(false);
  const [isCommentsOpen, setCommentsOpen] = useState<boolean>(false);
  const [isStatusOpen, setStatusOpen] = useState<boolean>(false);
  const [isCoversOpen, setCoversOpen] = useState<boolean>(false);
  const [isDurationOpen, setDurationOpen] = useState<boolean>(false);
  const [isDatOpen, setDateOpen] = useState<boolean>(false);
  const [isTimeOpen, setTimeOpen] = useState<boolean>(false);
  const [isTagOpen, setTagOpen] = useState<boolean>(false);
  const [isWaitOpen, setWaitOpen] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isTableError, setIsTableError] = useState<boolean>(false);
  const [waitESt, setWaitsEst] = useState<string>("0 min");
  const [isAlertVisible, setIsAlertVisible] = useState("");
  const [value, setValue] = useState<string>("");
  const [customersData, setCustomersData] = useState<any[]>([]);
  const [isCustomersOpen, setCustomersOpen] = useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>("");
  const [width, setWidth] = useState<any>(992);
  const [searchedCustomers, setSearchedCustomers] = useState<[]>([]);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isFailedSaveLoading, setIsFaileSaveLoading] = useState(false);
  const [isFailed, setIsFaile] = useState(
    localStorage.getItem("FAILED_RESERVE") ? true : false
  );
  const [blockedData, setBlockedData] = useState<any>([]);
  const [isTimeAlertVisible, setIsTimeAlertVisible] = useState<boolean>(false);

  const bookingStatus = useSelector(
    (state: RootState) => state.booking.bookingStatus
  );
  const allocatedTables = useSelector(
    (state: RootState) => state.booking.allocatedTables
  );
  const selectedFloorData = useSelector(
    (state: RootState) => state.booking.selectedFloorData
  );
  const locationId = useSelector(
    (state: RootState) => state.booking.locationId
  );
  // const organizationDetails = useSelector(
  //   (state: RootState) => state.booking.organizationDetails
  // );
  // const openingHours = organizationDetails?.OpeningHours?.filter(
  //   (day: any) => !day.Closed
  // ).map((day: any) => day.Day);
  const islocationSwitching = useSelector(
    (state: RootState) => state.booking.islocationSwitching
  );
  const isBlockOpen = useSelector(
    (state: RootState) => state.booking.isBlockOpen
  );
  useEffect(() => {
    searchCustomers("").then((res: any) => {
      if (res) {
        setSearchedCustomers(res);
      } else {
        setSearchedCustomers([]);
      }
    });
  }, []);
  useEffect(() => {
    window.addEventListener("online", () => {
      window.location.reload();
    });
  }, []);
  const searchCustomersLocal = (value: string): Promise<any[]> => {
    return new Promise((resolve) => {
      const filteredCustomers = searchedCustomers.filter((customer: any) => {
        const fullName =
          `${customer.Personal.FirstName} ${customer.Personal.LastName}`.toLowerCase();
        const email = customer.Email.toLowerCase();
        const phoneNumber = `${
          customer.PhoneNo.PhoneCode
        } ${customer.PhoneNo.Number.replace(/\s+/g, "")}`.toLowerCase();
        value = value.toLowerCase();
        return (
          fullName.includes(value) ||
          email.includes(value) ||
          phoneNumber.includes(value)
        );
      });
      resolve(filteredCustomers);
    });
  };
  const getStatusData = (name: string) => {
    return bookingStatus
      .flatMap((category) => category.Statuses)
      .find((status) => status.Name.toLowerCase() === name.toLowerCase());
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roundToNextQuarterHour = (time: moment.Moment): moment.Moment => {
    const minutes = time.minutes();
    const nextQuarterHour = Math.ceil(minutes / 15) * 15;
    if (nextQuarterHour === 60) {
      return time.add(1, "hour").startOf("hour").add(15, "minutes");
    }
    return time.minutes(nextQuarterHour).seconds(0);
  };
  const handleRoundTime = (timeStr: string) => {
    const time = moment(timeStr, "HH:mm");
    const rounded = roundToNextQuarterHour(time);
    return rounded.format("HH:mm");
  };
  const convertTimeToMinutesString = (timeString: any) => {
    const [hours, minutes] = timeString.split(":").map(Number);
    return hours * 60 + minutes;
  };
  const isTimeMatchingReservationWithDuration = (
    time: string,
    reservation: any
  ): boolean => {
    const givenTimeInMinutes = convertTimeToMinutesString(time);
    const bookingTimeInMinutes = convertTimeToMinutesString(
      reservation?.BookingDetails?.BookingTime
    );
    const endTimeInMinutes =
      bookingTimeInMinutes + reservation?.BookingDetails?.Duration;
    return (
      givenTimeInMinutes >=
        bookingTimeInMinutes - reservation?.BookingDetails?.Duration &&
      givenTimeInMinutes < endTimeInMinutes
    );
  };
  const isTimeMatchingReservation = () => {
    let reservations = selectedFloorData?.Tables?.flatMap(
      (item: any) => item.Reservations
    );
    if (reservations && reservations.length > 0) {
      return reservations.some((reservation: any) => {
        return reservation.AssetAllocation?.some((res: any) => {
          return allocatedTables.some((table: any) => {
            let dateValue = new Date(reservation?.BookingDetails?.BookingDate);

            let resDate = new Date(
              dateValue.getUTCFullYear(),
              dateValue.getUTCMonth(),
              dateValue.getUTCDate(),
              dateValue.getUTCHours(),
              dateValue.getUTCMinutes(),
              dateValue.getUTCSeconds()
            );
            return (
              res.RefNo === table.RefNo &&
              moment(resDate).format("DD-MM-yyyy") ===
                moment(date).format("DD-MM-yyyy") &&
              isTimeMatchingReservationWithDuration(
                handleRoundTime(bookingTime),
                reservation
              )
            );
          });
        });
      });
    }
  };
  // const getDayString = (day: number): string => {
  //   const daysOfWeek = [
  //     "Sunday",
  //     "Monday",
  //     "Tuesday",
  //     "Wednesday",
  //     "Thursday",
  //     "Friday",
  //     "Saturday",
  //   ];
  //   return daysOfWeek[day];
  // };
  // const getNextOpenDate = () => {
  //   let dayIndex = new Date().getDay();
  //   for (let i = 1; i <= 7; i++) {
  //     dayIndex = (dayIndex + 1) % 7;
  //     const dayString = getDayString(dayIndex);
  //     const nextOpeningHour = openingHours?.find(
  //       (day: any) => day === dayString
  //     );
  //     if (nextOpeningHour && !nextOpeningHour.Closed) {
  //       const nextOpenDate = new Date(date);
  //       nextOpenDate.setDate(date.getDate() + i);
  //       return nextOpenDate;
  //     } else {
  //       return new Date();
  //     }
  //   }
  // };
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.screen.width);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    let userDetails = localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails") || "")
      : "";
    if (userDetails === "" || userDetails === null) {
      navigate("/");
    }
    // setDate(getNextOpenDate());
  }, []);
  useEffect(() => {
    if (selectedCustomer !== "") {
      setFirstName(selectedCustomer.Personal.FirstName);
      setLastName(selectedCustomer.Personal.LastName);
      setEmail(selectedCustomer.Email);
      setPhoneNumber(
        selectedCustomer.PhoneNo.Number.replace(/\D+/g, "").replace(
          /^(\d{4})(\d+)/,
          "$1 $2"
        )
      );
    }
  }, [selectedCustomer]);

  const getMaxCapacitySum = () => {
    let totalCapacity = 0;
    for (const table of allocatedTables) {
      totalCapacity += table.Capacity.Max;
    }
    return totalCapacity;
  };
  const getMinCapacitySum = () => {
    let totalCapacity = 0;
    for (const table of allocatedTables) {
      totalCapacity += table.Capacity.Min;
    }
    return totalCapacity;
  };
  const handleCustomer = () => {
    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      const fName = urlParams.get("firstName");
      const lName = urlParams.get("lastName");
      const mail = urlParams.get("email");
      const num = urlParams.get("phone");
      if (fName) {
        setFirstName(fName);
      }
      if (lName) {
        setLastName(lName);
      }
      if (mail) {
        setEmail(mail);
      }
      if (num) {
        setPhoneNumber("+44" + num);
      }
    }
  };
  const handleDate = () => {
    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      const dateValue = urlParams.get("date");
      if (dateValue) {
        setDate(new Date(dateValue));
      }
    }
  };
  useEffect(() => {
    handleCustomer();
    handleDate();
    getStatus().then((response: any) => {
      dispatch(setBookingStatus(response));
      setStatusValue(getStatusData("Not_Confirmed"));
    });
    getTags().then((response: any) => {
      dispatch(setBookingTags(response));
    });
  }, []);
  useEffect(() => {
    if (!waitCheck && !walkCheck) {
      setWaitsEst("0 min");
      setStatusValue(getStatusData("Not_Confirmed"));
    }
    if (waitCheck) {
      setWaitsEst("15 mins");
      setStatusValue(getStatusData("Wait_List"));
    }
    if (!waitCheck && walkCheck) {
      setWaitsEst("0 min");
      setStatusValue(getStatusData("Confirmed"));
    }
  }, [waitCheck, walkCheck]);
  useEffect(() => {
    if (statusValue) {
      if (statusValue.DisplayName === "Wait List") {
        setWaitsEst("15 mins");
        setWaitCheck(true);
      } else {
        setWaitsEst("0 min");
        setWaitCheck(false);
      }
    }
  }, [statusValue]);
  useEffect(() => {
    if (allocatedTables.length === 0) {
      setIsAlertVisible("danger");
    } else if (getMaxCapacitySum() < guest && allocatedTables.length > 0) {
      setIsAlertVisible("warning-2");
    } else if (getMaxCapacitySum() / 2 > guest && allocatedTables.length > 0) {
      setIsAlertVisible("warning-3");
    } else {
      setIsAlertVisible("");
    }
  }, [guest, allocatedTables]);
  useEffect(() => {
    if (allocatedTables.length === 0) {
      setIsAlertVisible("danger");
    } else if (getMaxCapacitySum() < guest && allocatedTables.length > 0) {
      setIsAlertVisible("warning-2");
    } else if (getMaxCapacitySum() / 2 > guest && allocatedTables.length > 0) {
      setIsAlertVisible("warning-3");
    } else {
      setIsAlertVisible("");
    }
  }, [allocatedTables]);
  useEffect(() => {
    setIsTableError(isTimeMatchingReservation());
  }, [bookingTime, allocatedTables, date, selectedFloorData]);
  useEffect(() => {
    handleBlocked();
  }, [date]);
  useEffect(() => {
    handleBlocked();
  }, [isBlockOpen]);
  const handleBlocked = () => {
    getBlockedReservations(
      locationId || "",
      moment(date).format("YYYY-MM-DD")
    ).then((res) => {
      if (res) {
        setBlockedData(getInhouseTimeSlots(res));
        if (getInhouseTimeSlots(res).includes(handleRoundTime(bookingTime))) {
          setIsTimeAlertVisible(true);
        } else {
          setIsTimeAlertVisible(false);
        }
      }
    });
  };
  const getInhouseTimeSlots = (blocks: any) => {
    const slots: any[] = [];
    blocks.forEach((block: any) => {
      if (block.Configuration.InHouse) {
        const startTime = block.BlockTime.Start;
        const endTime = block.BlockTime.End;
        let start = new Date(`1970-01-01T${startTime}:00Z`);
        let end = new Date(`1970-01-01T${endTime}:00Z`);
        while (start < end) {
          const slotStart = start.toISOString().substring(11, 16);
          start.setMinutes(start.getMinutes() + 15);
          if (start <= end) {
            slots.push(slotStart);
          }
        }
      }
    });

    return slots.sort();
  };
  useEffect(() => {
    if (blockedData.length > 0) {
      if (blockedData.includes(handleRoundTime(bookingTime))) {
        setIsTimeAlertVisible(true);
      } else {
        setIsTimeAlertVisible(false);
      }
    }
  }, [bookingTime]);
  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const validateNumber = (number: string) => {
    const pattern = /^\d{4} \d{6}$/;
    if (!pattern.test(number.replace("+44", ""))) {
      return true;
    }
    return false;
  };
  const validateForm = (): boolean => {
    let valid = true;
    const newErrors = {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      rules: false,
      guest: "",
    };
    const regex = /^[A-Za-z]*$/;
    if (firstName.trim() === "") {
      newErrors.firstName = "*required";
      valid = false;
    }
    if (lastName.trim() === "") {
      newErrors.lastName = "*required";
      valid = false;
    }
    if (phoneNumber.trim() === "") {
      newErrors.phoneNumber = "*required";
      valid = false;
    }
    if (guest === 0) {
      newErrors.guest = "Party size cannot be empty";
      valid = false;
    } else if (guest > 100) {
      newErrors.guest = "Party size cannot be more than 100";
      valid = false;
    }
    if (validateNumber(phoneNumber)) {
      newErrors.phoneNumber = "*Invalid phone number";
      valid = false;
    }
    if (email !== "") {
      if (!validateEmail(email)) {
        newErrors.email = "*Invalid email format";
        valid = false;
      }
    }
    if (!regex.test(firstName.trim())) {
      newErrors.firstName = "*Only alphabetic characters are allowed.";
      valid = false;
    }
    if (!regex.test(lastName.trim())) {
      newErrors.lastName = "*Only alphabetic characters are allowed.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  const handleChange = (name: any) => {
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const detail = [
    {
      head: "Date",
      sub: <div>{moment(date).format("ddd, MMMM DD")}</div>,
      icon: calendar,
      hide: false,
      isOpen: isDatOpen,
    },
    {
      head: "Time",
      sub: (
        <TimeInput
          value={handleRoundTime(bookingTime)}
          setValue={setBookingTime}
          setTimeOpen={() => {
            setCommentsOpen(false);
            setStatusOpen(false);
            setDateOpen(false);
            setTimeOpen(!isTimeOpen);
            setTagOpen(false);
            setWaitOpen(false);
            setCoversOpen(false);
            setDurationOpen(false);
            setRequestOpen(false);
            setCustomersOpen(false);
          }}
          newReservation
          date={date}
        />
      ),
      icon: timeImg,
      hide: false,
      isOpen: isTimeOpen,
    },
    {
      head: "Party Size",
      sub: (
        <NumberInput
          value={guest}
          setValue={setGuest}
          setCoversOpen={() => {
            setCommentsOpen(false);
            setStatusOpen(false);
            setDateOpen(false);
            setTimeOpen(false);
            setTagOpen(false);
            setWaitOpen(false);
            setCoversOpen(!isCoversOpen);
            setDurationOpen(false);
            setRequestOpen(false);
            setCustomersOpen(false);
          }}
          newReservation
          onChange={() => {
            handleChange("guest");
          }}
        />
      ),
      icon: covers,
      hide: false,
      isOpen: isCoversOpen,
    },
    {
      head: "Duration",
      sub: (
        <DurationInput
          value={time}
          setValue={setTime}
          interval={interval}
          setDurationOpen={() => {
            setCommentsOpen(false);
            setStatusOpen(false);
            setDateOpen(false);
            setTimeOpen(false);
            setTagOpen(false);
            setWaitOpen(false);
            setCoversOpen(false);
            setDurationOpen(!isDurationOpen);
            setRequestOpen(false);
            setCustomersOpen(false);
          }}
          newReservation
        />
      ),
      icon: duration,
      hide: false,
      isOpen: isDurationOpen,
    },
    {
      head: "Table",
      sub: (
        <div style={{ columnGap: "0.5rem", display: "flex" }}>
          {allocatedTables.map((table) => {
            return <div>{table.Name}</div>;
          })}
        </div>
      ),

      icon: table,
      hide: false,
    },
    {
      head: "Status",
      sub: (
        <div
          style={{
            color: statusValue?.Color,
            display: "flex",
            alignItems: "center",
            columnGap: "5px",
          }}
        >
          <img alt='' src={statusValue?.Image} style={{ height: "14px" }} />
          {statusValue?.Name?.replace("_", " ")}
        </div>
      ),
      icon: status,
      hide: false,
      isOpen: isStatusOpen,
    },
    {
      head: "Wait Est.",
      sub: waitESt,
      icon: est,
      hide: !waitCheck,
      isOpen: isWaitOpen,
    },
    // {
    //   head: "Comments",
    //   sub: isCommentsOpen ? comments : comments === "" ? "None" : comments,
    //   icon: reserve,
    //   hide: false,
    //   isOpen: isCommentsOpen,
    // },
    // {
    //   head: "Tags",
    //   sub: <div>{tags.map((tag) => tag.Name)}</div>,
    //   icon: reserve,
    //   hide: false,
    //   isOpen: isTagOpen,
    // },
    {
      head: "Notes",
      sub: isRequestOpen ? request : request === "" ? "None" : request,
      icon: notes,
      hide: false,
      isOpen: isRequestOpen,
    },
  ];

  const handleItemOnClick = (item: string) => {
    switch (item) {
      case "Notes":
        setCommentsOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setWaitOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(!isRequestOpen);
        setCustomersOpen(false);

        break;
      case "Comments":
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setWaitOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setCommentsOpen(!isCommentsOpen);
        setCustomersOpen(false);

        break;
      case "Status":
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setWaitOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setCommentsOpen(false);
        setStatusOpen(!isStatusOpen);
        setCustomersOpen(false);

        break;
      case "Date":
        setTimeOpen(false);
        setTagOpen(false);
        setWaitOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setCommentsOpen(false);
        setStatusOpen(false);
        setDateOpen(!isDatOpen);
        setCustomersOpen(false);

        break;
      case "Time":
        setTagOpen(false);
        setWaitOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setCommentsOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(!isTimeOpen);
        setCustomersOpen(false);

        break;
      case "Tags":
        setWaitOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setCommentsOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(!isTagOpen);
        setCustomersOpen(false);

        break;
      case "Wait Est.":
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setCommentsOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setWaitOpen(!isWaitOpen);
        setCustomersOpen(false);

        break;
      default:
        break;
    }
  };
  const filteredDetail = detail.filter((item) => {
    return !item.hide;
  });

  const getAlert = () => {
    if (isAlertVisible === "danger") {
      return <Alert type='danger' content='You need to select a table.' />;
    } else if (isAlertVisible === "warning") {
      return <Alert type='warning' content={`Tables are over-utilized.`} />;
    } else if (isAlertVisible === "warning-2") {
      return (
        <Alert
          type='warning'
          content={`Tables are over-utilized. Maximum capacity is ${getMaxCapacitySum()}`}
        />
      );
    } else if (isAlertVisible === "warning-3") {
      return (
        <Alert
          type='warning'
          content={`Tables are under-utilized. Minimum  capacity is ${getMinCapacitySum()}`}
        />
      );
    }
  };
  const convertTimeToMinutes = (timeString: string) => {
    let totalMinutes = 0;

    // Use a regular expression to extract the numbers and their units
    const timeParts = timeString.match(/(\d+)\s*(h|min)/g);

    if (timeParts) {
      timeParts.forEach((part) => {
        if (part.includes("h")) {
          const hours = parseInt(part.replace("h", ""), 10);
          totalMinutes += hours * 60;
        } else if (part.includes("min")) {
          const minutes = parseInt(part.replace("min", ""), 10);
          totalMinutes += minutes;
        }
      });
    }

    return totalMinutes;
  };
  const convertMinutesToTime = (totalMinutes: number) => {
    let timeString = "";

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0) {
      timeString += `${hours}h `;
    }

    if (minutes > 0) {
      timeString += `${minutes}min`;
    }

    // Trim any trailing spaces
    return timeString.trim();
  };

  const transformArray = () => {
    return tags.map((item) => ({
      Id: item.TagID,
      Name: item.Name,
      Icon: item.Image,
    }));
  };
  const handleSubmit = () => {
    if (!isLoading) {
      if (
        validateForm() &&
        allocatedTables.length > 0 &&
        (isAlertVisible === "" ||
          (isAlertVisible !== "danger" && isAlertVisible !== "warning-2")) &&
        getMaxCapacitySum() >= guest
      ) {
        makeReserve("main");
      }
      if (
        validateForm() &&
        allocatedTables.length > 0 &&
        isAlertVisible === "warning-2"
      ) {
        setIsSaveOpen(true);
      }
    }
  };
  const makeReserve = (from: string) => {
    let statusObj = {
      Id: statusValue.StatusID,
      Icon: statusValue.Image,
      DiplayName: statusValue.DisplayName,
      Color: statusValue.Color,
      Category: {
        Id: statusValue.CategoryID,
        Name: "",
      },
      Name: statusValue.Name,
    };
    let reserve = {
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber
        .replace("+44", "")
        .replace(" ", "")
        .replace(/(\d{2})(\d{4})(\d{4})/, "$1 $2 $3"),
      email: email,
      date: moment(date).format("YYYY-MM-DD"),
      guest: guest,
      time: handleRoundTime(bookingTime),
      request: request,
      duration: convertTimeToMinutes(time),
      assets: allocatedTables,
      status: statusValue.DisplayName,
      statusInfo: statusObj,
      waitList: waitCheck,
      waitTime: convertTimeToMinutes(waitESt),
      walkIn: walkCheck,
      tags: transformArray(),
    };
    localStorage.setItem("FAILED_RESERVE", JSON.stringify(reserve));
    if (from === "main") {
      setIsLoading(true);
    } else {
      setIsSaveLoading(true);
    }
    makeReservationInhouse(reserve)
      .then((reserveObj: any) => {
        if (reserveObj) {
          localStorage.setItem(
            "selectedDate",
            JSON.stringify(date.toDateString())
          );
          setIsLoading(false);
          setIsSaveLoading(false);
          setIsSaveOpen(false);
          setIsFaile(false);
          clear();
          setIsSuccess(true);
        } else {
          setIsLoading(false);
          setIsSaveLoading(false);
          setIsSaveOpen(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
        setIsSaveLoading(false);
        setIsSaveOpen(false);
      });
  };
  const reReserve = () => {
    const data = localStorage.getItem("FAILED_RESERVE")
      ? JSON.parse(localStorage.getItem("FAILED_RESERVE") || "")
      : "";
    setIsFaileSaveLoading(true);
    if (data === "") {
      setIsFaileSaveLoading(false);
    }
    if (data !== "" && !isFailedSaveLoading) {
      makeReservationInhouse(data)
        .then((reserveObj: any) => {
          if (reserveObj) {
            localStorage.setItem(
              "selectedDate",
              JSON.stringify(date.toDateString())
            );
            setIsFaileSaveLoading(false);
            setIsFaile(false);
            clear();
            setIsSuccess(true);
          } else {
            setIsFaileSaveLoading(false);
            setIsFaile(false);
          }
        })
        .catch(() => {
          setIsFaileSaveLoading(false);
          setIsFaile(false);
        });
    }
  };
  const clear = () => {
    setWaitsEst("0 min");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setGuest(1);
    setRequest("");
    setWaitCheck(false);
    setWalkCheck(false);
    setBookingTime(moment(new Date()).format("HH:mm"));
    setDate(new Date());
    setTime("15 mins");
    setStatusValue("");
    setTagsData([]);
    dispatch(setAllocatedTables([]));
    setIsAlertVisible("");
    localStorage.removeItem("FAILED_RESERVE");
  };
  const closeTabs = () => {
    setCommentsOpen(false);
    setStatusOpen(false);
    setDateOpen(false);
    setTimeOpen(false);
    setTagOpen(false);
    setWaitOpen(false);
    setCoversOpen(false);
    setDurationOpen(false);
    setRequestOpen(false);
    setCustomersOpen(false);
  };
  const reformatNumber = (numberString: string) => {
    const cleanedNumber = numberString.replace(/\s/g, "");
    const part1 = cleanedNumber.slice(0, 4).padStart(4, "0");
    const part2 = cleanedNumber.slice(4).padStart(6, "0");

    return `${part1} ${part2}`;
  };

  const revertReservation = () => {
    const data = localStorage.getItem("FAILED_RESERVE")
      ? JSON.parse(localStorage.getItem("FAILED_RESERVE") || "")
      : "";
    if (data !== "") {
      setFirstName(data.firstName);
      setLastName(data.lastName);
      setPhoneNumber(reformatNumber(data.phoneNumber));
      setEmail(data.email);
      setDate(new Date(data.date));
      setGuest(data.guest);
      setBookingTime(handleRoundTime(data.time));
      setRequest(data.request);
      setTime(convertMinutesToTime(data.duration));
      dispatch(setAllocatedTables(data.assets));
      setStatusValue(getStatusData(data.statusInfo.Name));
      setWaitCheck(data.waitList);
      setWaitsEst(data.waitTime);
      setWalkCheck(data.walkIn);
      localStorage.removeItem("FAILED_RESERVE");
    }
  };
  return (
    <div className='Reservation'>
      {
        islocationSwitching ? (
          <div className='empty'>
            <div className='loader' />
          </div>
        ) : (
          //  width > 900 ?
          <>
            {isDrawerOpen ? (
              <Drawer
                isDrawerOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
                selectedMenu={"ADD"}
              />
            ) : (
              <SideBar
                isDrawerOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
                selected={"ADD"}
              />
            )}
            <div
              className='reservation-content'
              style={{ marginLeft: isDrawerOpen ? "16.25rem" : "5rem" }}
            >
              <TopBar
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                title='New Reservation'
                isOpenDrawer={isDrawerOpen}
                blocked
              />
              <div className='reservation-view'>
                <div className='left-view'>
                  <div className='search-bar'>
                    <SearchInput
                      value={value}
                      onChange={(e) => {
                        setValue(e);
                        searchCustomersLocal(e).then((res: any) => {
                          if (res) {
                            res.sort((a: any, b: any) => {
                              const firstLetterA =
                                a.Personal?.FirstName[0]?.toUpperCase();
                              const firstLetterB =
                                b.Personal?.FirstName[0]?.toUpperCase();
                              return firstLetterA.localeCompare(firstLetterB);
                            });
                            setCustomersOpen(true);
                            setCustomersData(res);
                          }
                        });
                      }}
                      placeholder='Search...'
                    />
                  </div>
                  <div className='guest-info' onClick={closeTabs}>
                    <div className='header'>
                      <img alt='' src={guestImg} />
                      Guest
                    </div>
                    <div className='name-container'>
                      <div className='left'>
                        <InputComponent
                          label=''
                          value={firstName}
                          onChange={(value) => {
                            handleChange("firstName");
                            setFirstName(value);
                          }}
                          disabled={false}
                          fontSize='0.75rem'
                          placeholder='First Name*'
                          isRequired
                        />
                        {errors.firstName && (
                          <span className='error'>{errors.firstName}</span>
                        )}
                      </div>
                      <div className='left'>
                        <InputComponent
                          label=''
                          value={lastName}
                          onChange={(value) => {
                            handleChange("lastName");
                            setLastName(value);
                          }}
                          disabled={false}
                          fontSize='0.75rem'
                          placeholder='Last Name*'
                          isRequired
                        />
                        {errors.lastName && (
                          <span className='error'>{errors.lastName}</span>
                        )}
                      </div>
                    </div>
                    <div className='name-container'>
                      <div className='left'>
                        <InputComponent
                          label=''
                          value={email}
                          onChange={(value) => {
                            handleChange("email");
                            setEmail(value);
                          }}
                          disabled={false}
                          fontSize='0.75rem'
                          placeholder='Email'
                          isRequired={false}
                        />
                        {errors.email && (
                          <span className='error'>{errors.email}</span>
                        )}
                      </div>
                      <div className='right'>
                        <NumberInputComponent
                          label=''
                          value={phoneNumber}
                          fontSize='0.75rem'
                          onChange={(value: number) => {
                            handleChange("phoneNumber");
                            setPhoneNumber(
                              value
                                .toString()
                                .replace("+44 ", "")
                                .replace("+", "")
                            );
                          }}
                        />
                        {errors.phoneNumber && (
                          <span className='error'>{errors.phoneNumber}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='status-container' onClick={closeTabs}>
                    <div className='item'>
                      <div
                        className='check'
                        onClick={() => {
                          setWalkCheck(!walkCheck);
                        }}
                      >
                        {walkCheck && (
                          <div className='checked'>
                            <img alt='' src={tick} />
                          </div>
                        )}
                      </div>
                      <img alt='' src={walk} />
                      Walk-In
                    </div>
                    <div className='item'>
                      <div
                        className='check'
                        onClick={() => {
                          setWaitCheck(!waitCheck);
                        }}
                      >
                        {waitCheck && (
                          <div className='checked'>
                            <img alt='' src={tick} />
                          </div>
                        )}
                      </div>
                      <img alt='' src={wait} />
                      Wait List
                    </div>
                  </div>
                  <div className='inner-container'>
                    {filteredDetail.map((item, index) => {
                      return (
                        <div className='item-cont ' key={index}>
                          {item.head === "Table" &&
                            isAlertVisible !== "" &&
                            getAlert()}

                          <div
                            className={`${
                              item.head === "Time" ||
                              item.head === "Party Size" ||
                              item.head === "Duration"
                                ? "item-def "
                                : "item"
                            } ${item.isOpen ? "item-sel" : ""}`}
                            onClick={() => {
                              if (
                                item.head === "Date" ||
                                item.head === "Status" ||
                                item.head === "Notes" ||
                                item.head === "Wait Est."
                              ) {
                                handleItemOnClick(item.head);
                              }
                            }}
                          >
                            <div className='det'>
                              <div
                                className={`head ${
                                  item.isOpen ? "gradient-text" : ""
                                }`}
                              >
                                <img alt='' src={item.icon} />
                                {item.head}
                              </div>
                              <div className='sub'>{item.sub}</div>
                            </div>
                            {item.head !== "Party Size" &&
                              item.head !== "Duration" &&
                              item.head !== "Time" && (
                                <div
                                  className={
                                    item.isOpen
                                      ? "arrow-cont-sel"
                                      : "arrow-cont"
                                  }
                                >
                                  <img
                                    alt=''
                                    src={item.isOpen ? arrow : back}
                                  />
                                </div>
                              )}
                          </div>
                          {errors.guest !== "" &&
                            item.head === "Party Size" && (
                              <Alert type='danger' content={errors.guest} />
                            )}
                          {item.head === "Time" && isTimeAlertVisible && (
                            <Alert
                              type='warning'
                              content='The selected time slot is blocked.'
                            />
                          )}
                          {isRequestOpen && (
                            <NotesModal
                              notes={request}
                              setNotes={setRequest}
                              isOpen={true}
                              onClose={() => {
                                setRequestOpen(false);
                              }}
                              isEdit={false}
                            />
                          )}
                          {isCommentsOpen && (
                            <CommentModal
                              comment={comments}
                              setComment={setComments}
                              isOpen={true}
                              onClose={() => {
                                setCommentsOpen(false);
                              }}
                            />
                          )}
                          {isDatOpen && (
                            <DateModal
                              date={date}
                              setDate={setDate}
                              setDateOpen={setDateOpen}
                              isOpen={isDatOpen}
                              onClose={() => {
                                setDateOpen(false);
                              }}
                              isEdit={false}
                            />
                          )}
                          {isStatusOpen && (
                            <StatusModal
                              isOpen={isStatusOpen}
                              onClose={() => {
                                setStatusOpen(false);
                              }}
                              setStatus={setStatusValue}
                              isEdit={false}
                            />
                          )}
                          {isTagOpen && (
                            <TagModal
                              isOpen={isTagOpen}
                              onClose={() => {
                                setTagOpen(false);
                              }}
                              setTags={setTagsData}
                              tags={tags}
                              isEdit={false}
                            />
                          )}
                          {isCoversOpen && (
                            <CoverModal
                              isOpen={isCoversOpen}
                              onClose={() => {
                                setCoversOpen(false);
                              }}
                              cover={guest}
                              setCover={setGuest}
                              isEdit={false}
                            />
                          )}
                          {isTimeOpen && (
                            <TimeModal
                              time={handleRoundTime(bookingTime)}
                              setTime={setBookingTime}
                              isOpen={isTimeOpen}
                              onClose={() => {
                                setTimeOpen(false);
                              }}
                              isEdit={false}
                              date={date}
                            />
                          )}
                          {isDurationOpen && (
                            <DurationModal
                              isOpen={isDurationOpen}
                              onClose={() => {
                                setDurationOpen(false);
                              }}
                              interval={interval}
                              setInterval={setInterval}
                              isEdit={false}
                            />
                          )}
                          {isWaitOpen && (
                            <EstModal
                              isOpen={isWaitOpen}
                              onClose={() => {
                                setWaitOpen(false);
                              }}
                              waitEst={waitESt}
                              setWaitEst={setWaitsEst}
                              isEdit={false}
                            />
                          )}
                          {isCustomersOpen && (
                            <CustomerModal
                              onClose={() => {
                                setValue("");
                                setCustomersData([]);
                                setCustomersOpen(false);
                              }}
                              data={customersData}
                              setSelectedCustomer={setSelectedCustomer}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className='btn-container'>
                    <Button
                      text='MAKE RESERVATION'
                      auth
                      onClick={handleSubmit}
                      loading={isLoading}
                    />
                  </div>
                </div>
                <div className='right-view' onClick={closeTabs}>
                  <FloorView
                    date={moment(date).format("YYYY-MM-DD")}
                    isView={false}
                    time={handleRoundTime(bookingTime)}
                    isDrawerOpen={isDrawerOpen}
                    isNew={true}
                  />
                </div>
              </div>
            </div>
            <SuccessModal
              isOpen={isSuccess}
              onClose={() => {
                setIsSuccess(false);
              }}
              onOk={() => {
                navigate("/v1/booking/floor-view");
              }}
              header='Reservation successful!'
              content=' Your reservation has been successfully completed. Please refer to the
          floor view for detailed information about your booking.'
            />
            <TableErrorModal
              isOpen={isTableError}
              onClose={() => {
                dispatch(setAllocatedTables([]));
                setIsTableError(false);
              }}
              content={`The selected table is not available for the chosen booking time ${handleRoundTime(
                bookingTime
              )}. Please select a different table or time slot`}
            />
            <WarningModal
              isOpen={isSaveOpen}
              onClose={() => {
                setIsSaveOpen(false);
              }}
              onOk={() => {
                if (!isSaveLoading) {
                  makeReserve("modal");
                }
              }}
              content='The selected table(s) are over-utilized. Would you like to make a reservation?'
              isLoading={isSaveLoading}
              header='Warning'
              secondary={true}
              primaryText='Make Reservation'
              secondaryText='Cancel'
            />
            {isFailed && (
              <BookingFailed
                onClose={() => {
                  revertReservation();
                  setIsFaile(false);
                }}
                onOk={() => {
                  reReserve();
                }}
                isLoading={isFailedSaveLoading}
                header='Warning'
                secondary={true}
                primaryText='Retry Reservation'
                secondaryText='Cancel'
              />
            )}
          </>
        )
        // : (
        //   <div className='landscape'>
        //     Please rotate your device to landscape mode
        //   </div>
        // )
      }
    </div>
  );
};
export default NewReservation;
